import AddIcon from '@mui/icons-material/Add';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { CardComponent } from 'utils/components/card/CardComponent';
import { sanitizeInput } from 'utils/helpers/sanitizeInput/sanitizeInput';

export const AddLineForm = ({
  register,
  errors,
  dataValidation,
  handleSubmit,
  addLineForm,
  loading,
  setValue,
}) => {
  return (
    <CardComponent title='Agregar línea' minWidth='100%'>
      <Grid container spacing={3} sx={{ width: '100%' }} mt={3} height={100}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Número teléfonico
          </Typography>
          <TextField
            fullWidth
            placeholder='Número telefónico'
            {...register('direct_number', dataValidation.direct_number)}
            error={Boolean(errors.direct_number)}
            helperText={errors.direct_number?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'digits');
              setValue('direct_number', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ marginTop: '28px' }}>
          <Button
            fullWidth
            onClick={handleSubmit(addLineForm)}
            variant='outlined'
            startIcon={<AddIcon />}
            style={{ color: '#fff', backgroundColor: '#6242a2' }}
            disabled={loading}
          >
            Agregar
          </Button>
        </Grid>
      </Grid>
    </CardComponent>
  );
};
